import { ContactFormState } from '@/models/ContactFormState';
import { ContactSurSiteFormState } from '@/models/ContactSurSiteForm';
import { Delai } from '@/models/Delai';
import { DemandeInterventionContact } from '@/models/DemandeInterventionContact';
import { EquipementItems } from '@/models/EquipementItems';
import { EtatEquipement } from '@/models/EtatEquipement';
import { InterventionRequestResponse } from '@/models/InterventionRequestResponse';
import { Site } from '@/models/Site';
import { TypeItems } from '@/models/TypeItems';
import { EquipementState } from './modules/Equipement';

export interface CoordonneesAstreinte {
    societe: string;
    telephone: string;
}

export interface DemandeInterventionState {
    equipementModule?: EquipementState;
    step: number;
    site?: Site;
    sites?: Site[]
    type?: TypeItems;
    delai?: Delai;
    dateAutre: string;
    equipement?: EquipementItems | null;
    etatEquipement?: EtatEquipement;
    objet: string;
    descriptif: string;
    documents: File[];
    suivi: boolean;
    recurrente: boolean;
    contactSurSite: ContactSurSiteFormState;
    listeContactSurSite: ContactSurSiteFormState[];
    contacts: DemandeInterventionContact[];
    listeContacts: ContactFormState[];

    isLoading: boolean;
    error: boolean;
    success: boolean;
    response: InterventionRequestResponse | null;
    isHeureAstreinte: boolean;
    isJourFerie: boolean;
    coordonneesAstreinte: CoordonneesAstreinte[];
    coordonneesJourFerie: CoordonneesAstreinte[];
}

export const initialState: DemandeInterventionState = {
    step: 1,
    objet: '',
    descriptif: '',
    suivi: false,
    recurrente: false,
    contacts: [],
    isLoading: false,
    error: false,
    success: false,
    contactSurSite: {
        firstname: '',
        lastname: '',
        telephoneMobile: '',
        telephoneFixe: '',
        isConnectedUser: false,
    },
    listeContactSurSite: [],
    listeContacts: [],
    documents: [],
    dateAutre: '',
    response: null,
    isHeureAstreinte: false,
    isJourFerie: false,
    coordonneesAstreinte: [{
        societe: '',
        telephone: '',
    }],
    coordonneesJourFerie: []
};

export const state: DemandeInterventionState = {
    ...initialState
};
